import { Expose } from 'class-transformer';
import { BaseModel } from '@lib/common-sdk';

export class WasteModel extends BaseModel {
  @Expose()
  code: string | undefined;

  @Expose()
  description: string | undefined;

  @Expose()
  hazardous: boolean | undefined = false;
}
